import { Plus, Users } from 'lucide-react';
import { useState } from 'react';

import CreateTrialTeamModal from '@/components/CreateTrialTeamModal';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { UserDetail } from '@/types/users';

interface CreateTrialTeamSectionProps {
  user: UserDetail;
}

const PAID_PLANS = [
  'plus_monthly',
  'plus_annual',
  'power_monthly',
  'power_annual',
  'pro_monthly',
  'pro2_monthly',
];

export default function CreateTrialTeamSection({
  user,
}: CreateTrialTeamSectionProps) {
  const [open, setOpen] = useState(false);

  const ownerHasIndividualSub = !!user.plan && PAID_PLANS.includes(user.plan);

  return (
    <>
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between gap-4">
            <div>
              <CardTitle className="flex items-center gap-2">
                <Users className="h-4 w-4" />
                Create team with trial
              </CardTitle>
              <CardDescription>
                Set this user up as a team owner with a trialing subscription.
                No payment method required.
                {ownerHasIndividualSub &&
                  ' Their individual plan is cancelled when the team is created, and its unused time is credited to the team.'}
              </CardDescription>
            </div>
            <span className="inline-flex items-center rounded-full bg-muted px-2.5 py-1 text-xs font-medium">
              Creates a new team
            </span>
          </div>
        </CardHeader>
        <CardContent>
          <Button onClick={() => setOpen(true)}>
            <Plus className="h-4 w-4 mr-2" />
            Create team with trial
          </Button>
        </CardContent>
      </Card>

      <CreateTrialTeamModal
        isOpen={open}
        onClose={() => setOpen(false)}
        ownerEmail={user.email}
      />
    </>
  );
}
